import {Fragment} from 'react';
import {useDispatch} from 'react-redux';
import './style.css';

import classNames from 'classnames';
import {useCookies} from 'react-cookie';
import {useQueryClient} from 'react-query';
import {useLocation} from 'react-router-dom';
import {useAuth} from '../../../../context/authContext';
import {HOME_TRAGET} from '../../../../services/config';
import {clearAllData} from '../../../../store/redux/addPictureAdvertisment';
import {
  addFormData,
  addOptionalFormData,
  addRegisterAdvertisement,
  resetRegisterAdvertisement,
} from '../../../../store/redux/advertisementRegisteration';
import {googleAnalyticsInstance} from '../../../../utilities/helper/googleAnalitics';
import NavLinkItem from './navLinkItem';
export interface Action {
  label: string;
  icon: string;
  activeIcon: string;
  route: string;
}
export interface IFeatures {
  id: number;
  label: string;
  route: string;
  icon: string;
  activeIcon: string;
  action: (item: Action) => JSX.Element;
}
interface MainFooterProps {
  isScrolling?: boolean;
  onClick?: () => void;
  className?: string;
}
const MainFooter = ({isScrolling, onClick, className}: MainFooterProps) => {
  const dispatch = useDispatch();
  const {supplierProfile} = useAuth();
  const location = useLocation();
  const [cookie] = useCookies(['access_token']);
  const isHome = location.pathname.includes('home');
  const queryClient = useQueryClient();
  const homeNavigateHandler = () => {
    if (isHome) {
      if (cookie?.access_token?.access_token) {
        window.location.replace(HOME_TRAGET as string);
      }
      googleAnalyticsInstance.eventGoogleAnalytics({
        category: 'home',
        action: 'رو خانه از فوتر کلیک شد',
      });
    }
  };
  const shopNavigateHandler = async () => {
    await queryClient.refetchQueries({
      queryKey: ['getProfile'],
    });
  };
  const labelChooser = () => {
    if (isHome) {
      if (cookie?.access_token?.access_token) {
        return 'برگشت به مزرعه';
      }
    }
    return 'خانه';
  };

  const links: Array<IFeatures> = [
    {
      id: 1,
      label: labelChooser(),
      icon: 'icon-nameHome',
      activeIcon: 'icon-nameHome1',
      route: '/home',
      action: ({icon, label, activeIcon, route}) => (
        <NavLinkItem
          route={route}
          activeIcon={activeIcon}
          icon={icon}
          label={label}
          onClick={
            onClick
              ? () => {
                  onClick();
                  homeNavigateHandler();
                }
              : () => {
                  dispatch(addOptionalFormData(''));
                  dispatch(resetRegisterAdvertisement({}));
                  addRegisterAdvertisement({
                    input_group: undefined,
                    input: undefined,
                  });
                  dispatch(addFormData(''));
                  dispatch(clearAllData());
                  homeNavigateHandler();
                }
          }
        />
      ),
    },
    {
      id: 2,
      label: 'دسته‌بندی',
      icon: 'icon-nameCategory',
      activeIcon: 'icon-nameCategory1',
      route: '/categories',
      action: ({icon, label, activeIcon, route}) => (
        <NavLinkItem
          route={route}
          activeIcon={activeIcon}
          icon={icon}
          label={label}
          onClick={() =>
            googleAnalyticsInstance.eventGoogleAnalytics({
              category: 'َcategories',
              action: 'رو دسته بندی از فوتر کلیک شد',
            })
          }
        />
      ),
    },
    {
      id: 3,
      label: 'ثبت آگهی',
      icon: 'icon-size24142',
      activeIcon: 'icon-size24142',
      route: '/advertisement-registeration',
      action: ({icon, label, activeIcon, route}: Action) => (
        <NavLinkItem
          route={route}
          activeIcon={activeIcon}
          icon={icon}
          label={label}
          onClick={shopNavigateHandler}
        />
      ),
    },

    {
      id: 4,
      label: 'فروشگاه من',
      icon: 'icon-nameStore',
      activeIcon: 'icon-nameStore1',
      route:
        supplierProfile?.store?.guid || supplierProfile?.lab?.guid
          ? '/my-store-info'
          : '/my-store',
      action: ({icon, label, activeIcon, route}: Action) => (
        <NavLinkItem
          route={route}
          activeIcon={activeIcon}
          icon={icon}
          label={label}
          onClick={shopNavigateHandler}
        />
      ),
    },
    {
      id: 5,
      label: 'حساب من',
      icon: 'icon-nameProfile',
      activeIcon: 'icon-nameProfile1',
      route: '/my-account',
      action: ({icon, label, activeIcon, route}) => (
        <NavLinkItem
          route={route}
          activeIcon={activeIcon}
          icon={icon}
          label={label}
          onClick={onClick}
        />
      ),
    },
  ];

  return (
    <div className={`${className ? className : 'flex z-10'}`}>
      <div
        className={classNames(
          'flex w-full items-center justify-around  home-farm-footer-wrapper bg-white shadow-dropShadow',
          {
            'home-farm-footer-open': !isScrolling,
            'home-farm-footer-close': isScrolling,
          },
        )}
      >
        {links.map(item => (
          <Fragment key={item.id}>
            {item.action({
              icon: item.icon,
              label: item.label,
              activeIcon: item.activeIcon,
              route: item.route,
            })}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default MainFooter;
